<style>
</style>
<template>
<v-select ref="select" solo flat persistent-hint :hint="$t(labelValue)" :label="$t(labelValue)" :items="items" :value="inputValue" @input="getInput" :required="required" v-if="!hidden">
  <template slot="selection" slot-scope="data">
    <template v-if="data.item.cca2 !== undefined">
      <v-row no-gutters>
        <v-col cols="2">
          <flag :iso="data.item.cca2" :squared="false" :title="getLocalizedOfficialName(data.item)" />
        </v-col>
        <v-col cols="10">
          <div>{{ getLocalizedOfficialName(data.item) }}</div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row no-gutters>
        <v-col cols="2">
          <flag :iso="inputValue.cca2" :squared="false" :title="getLocalizedOfficialName(inputValue)" />
        </v-col>
        <v-col cols="10">
          <div>{{ getLocalizedOfficialName(inputValue) }}</div>
        </v-col>
      </v-row>
    </template>
  </template>
  <template slot="item" slot-scope="data">
    <template v-if="data.item.cca2 === undefined">
      <div class="caption grey--text">{{ $t(data.item.name) }}</div>
    </template>
    <template v-else>
      <v-row no-gutters>
        <v-col cols="2">
          <flag :iso="data.item.cca2" :squared="false" :title="getLocalizedOfficialName(data.item)" />
        </v-col>
        <v-col cols="10">
          <div>{{ getLocalizedOfficialName(data.item) }}</div>
        </v-col>
      </v-row>
    </template>
  </template>
</v-select>
</template>
<script>
import CountryMixin from '../mixins/country-mixin.js'
import TransformMixin from '../mixins/transform-mixin.js'
import Flag from '../components/flag.vue'

export default {
  name: 'select-country',
  props: {
    name: {
      type: String,
      default: 'title'
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Flag
  },
  mixins: [CountryMixin, TransformMixin],
  data() {
    return {
      region: null,
      rules: {
        required: (v) => !!v || !this.required || this.transform(this.labelValue)
      }
    }
  },
  computed: {
    labelValue: {
      get() {
        return this.label ? this.label : this.name
      }
    },
    inputValue: {
      get() {
        const country = this.getCountry(this.value ? this.value : 'CZ')
        if (!this.value) {
          this.getInput(country)
        }
        return country
      }
    },
    items: {
      get() {
        // return this.regions.filter(item => item.region === undefined || item['region'] === this.region || item.cca2 === this.value)
        return this.filteredCountries
      }
    }
  },
  methods: {
    getInput(value) {
      if (value) {
        if (value.cca2 !== undefined) {
          this.$emit('input', value.cca2)
        } else {
          this.region = this.region !== value.name ? value.name : null
        }
      }
    }
  },
  watch: {
    region() {
      this.$refs.select.isMenuActive = true
    }
  }
}
</script>
